import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function RedactedThinkingBlock({
  block: __block
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    "data-block-type": "redacted-thinking",
    alignItems: "center",
    gap: "200",
    paddingBlock: "200",
    paddingInline: "300",
    borderRadius: "200",
    borderWidth: "100",
    borderStyle: "dashed",
    borderColor: "border-core-default",
    backgroundColor: "fill-surface-default",
    children: [/*#__PURE__*/_jsx(LockedIcon, {
      size: "300"
    }), /*#__PURE__*/_jsx(Text, {
      use: "help",
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "breezeEngineChatComponents.blocks.thinkingRedacted"
      })
    })]
  });
}